<template>
  <div class="scroll-slider">
    <div ref="self" class="scroll-slider__wrapper" :class="{ 'scroll-slider__wrapper--contact': pageName == 'contact'}">
      <div ref="imgWrapper" class="scroll-slider__wrapper-img">
        <Picture v-for="(item, index) in data.items" :key="index" from="asset" :parallax="textArray ? false : true" :src="item" ratio="96x120" class="location__img location__img-scroll" />
      </div>
    </div>
    <div v-if="textArray" ref="text" class="l-mdl--8 l-mdl--4s scroll-slider__text-wrap">
      <span class="t-h--13 t-h--11s">
        <span class="t--fak">@ </span>
      </span>
      <span class="t-h--13 t-h--11s scroll-slider__text-item" v-for="(item, index) in data.nicknames" :key="index">
        <span class="t--fak scroll-slider__text">{{ item }}</span>
      </span>
    </div>
  </div>
</template>

<script>
import * as $ from "fxdom";
import * as _ from "fxjs";
import { gsap, ScrollTrigger } from "gsap/all";
import { ref, reactive, onMounted, onUnmounted, useStore } from "@/helper/vue.js";
import { sample } from "@/helper/gadget.js";
import Picture from "@/parts/picture/PictureView.vue";
import { nextTick } from '@vue/runtime-core';
import { stPos, normalize } from "@/helper/gadget.js";

export default {
  props: [ "imgRoot", "imgNum", "textArray", "pageName" ],
  components: {
    Picture
  },
  name: "PicScrollSlider",
  setup(props) {
    const data = reactive({
      items: [],
      nicknames: []
    })
    const self = ref();
    const text = ref();
    const imgWrapper = ref();
    const { state } = useStore();
    let displayLimit = props.pageName == "about" ? 40 : props.imgNum;

    const setImgArray = () => {

      if(props.pageName == "about") {
        _.go(
          sample(_.range(props.imgNum), displayLimit),
          _.each(index => {
            data.items.push(`${props.imgRoot}${index}.jpg`);
            data.nicknames.push(props.textArray[index]);
          })
        );
      }
      else {
        for (let i = 0; i < displayLimit; i++) {
          // let num = i < 9 ? `0${i + 1}` : i + 1;
          data.items.push(`${props.imgRoot}${i}.jpg`)
        }
      }
    }

    const getTlGroup = (group) => {
			return ScrollTrigger.getAll().filter(t => t.vars.group === group);
		}

		const cleanTlGroup = (name) => {
			getTlGroup(name).forEach(tl => tl.kill());
		}

    const updatePicture = () => {
      nextTick(() => {
        const triggerTarget = props.pageName == 'about' ? $.qs('.i-member') : self.value;
        const targetImg = gsap.utils.toArray(self.value.querySelectorAll('.location__img'));
        let targetText;
        let targetTextItem;
        if (props.textArray) {
          targetText = gsap.utils.toArray(text.value.querySelectorAll('.scroll-slider__text'));
          targetTextItem = gsap.utils.toArray(text.value.querySelectorAll('.scroll-slider__text-item'));
        }

        targetImg.forEach((el, index, arr) => {
          $.setCss({ overflow: 'hidden' }, el)
        })

        const event = () => {
          gsap.timeline({
            scrollTrigger: {
              group: 'changeImgGroup',
              trigger: triggerTarget,
              start: e => stPos(e, 0, 1),
              end: e => stPos(e, 1, 0),
              scrub: 0,
              onUpdate({ progress }) {
                let stayT; // 이미지 opacity 안 변하고 보여지는 시간 (비율)
                let opacT; // 이미지 opacity 변하는 시간 (비율)
                let delayD;

                let totalT;
                let durByImgNum;
                let totalD;
                let OpacD;
                let firstImgOpacityP;

                if (props.pageName == 'about') {
                  stayT = 2;
                  opacT = 1;
                  delayD = 0;
                  totalT = stayT + opacT;
                  durByImgNum = 1/(displayLimit * (totalT));
                  totalD = durByImgNum * totalT;
                  OpacD = durByImgNum * opacT;
                  firstImgOpacityP = normalize(progress, 0, totalD);
                } else {
                  stayT = 6;
                  opacT = 1;
                  delayD = 0.3;
                  totalT = stayT + opacT;
                  durByImgNum = (1 - delayD * 2)/(displayLimit * (totalT));
                  totalD = durByImgNum * totalT;
                  OpacD = durByImgNum * opacT;
                  firstImgOpacityP = normalize(progress, 0, delayD + totalD);
                }
                targetImg.forEach((el, index, arr) => {
                  let oneImgOpacityP;
                  let oneImgScaleP;

                  if (props.pageName == 'about') {
                    const visCond = index == 0 ? progress < totalD : totalD * index - OpacD < progress && progress < totalD * (index + 2);
                    oneImgOpacityP = normalize(progress, totalD * index - OpacD, totalD * index);
                    oneImgScaleP = normalize(progress, totalD * index - OpacD, totalD * (index + 1));
                    if (visCond) {
                      gsap.set(targetImg[index], {visibility: 'visible'});
                    } else {
                      gsap.set(targetImg[index], {visibility: 'hidden'});
                    }
                  } else {
                    oneImgScaleP = normalize(progress, delayD + totalD * index - OpacD, index == (displayLimit - 1) ? 1 : delayD + totalD * (index + 1));
                    oneImgOpacityP = normalize(progress, delayD + totalD * index - OpacD, delayD + totalD * index);
                  }

                  if (index == 0) {
                    let valZ;
                    if(props.pageName == "about") {
                      valZ = 20 - (firstImgOpacityP * 19);
                    }
                    else {
                      valZ = 50 - (firstImgOpacityP * 40);
                    }
                    gsap.set(el, {z: valZ });
                  } else {
                    let valZ;
                    if(props.pageName == "about") {
                      valZ = 20 - (oneImgScaleP * 19);
                    }
                    else {
                      valZ = 50 - (oneImgScaleP * 40);
                    }
                    gsap.set(el, {z: valZ, opacity: oneImgOpacityP });
                    if (props.textArray) {
                      gsap.set(targetTextItem[index - 1], {opacity: 1 - oneImgOpacityP})
                      gsap.set(targetText[index], {opacity: oneImgOpacityP})
                    }
                  };
                })
              },
            }
          });
        }

        if(state.pageState != "landed") {
          window.addEventListener("landed", event, { once: true });
        } else {
          event();
        }
      });
    }

    onMounted(() => {
      setImgArray();
      updatePicture();
    });

    onUnmounted(() => {
      cleanTlGroup("changeImgGroup");
    });

    return {
      data,
      self,
      text,
      imgWrapper
    }
  }
}
</script>

<style scoped lang="scss" src="@/css/contact.scss"></style>
<style scoped lang="scss">
.scroll-slider {
  &__wrapper {
    position: relative;
    overflow: hidden;
    height: 100%;
    &:after {
      content: '';
      display: block;
      padding-top: 125%;
    }
    &--contact {
      &:after {
        content: '';
        display: block;
        padding-top: 125%;
        .w1600__ & {
          padding-top: 100%;
        }
        .__w600 & {
          padding-top: 126%;
        }
      }
    }

    & .m-pic:not(:first-child) {
      opacity: 0;
    }

    &-img {
      height: 100%;
      perspective: 300px;
    }
  }
  &__text {
    position: absolute;
    top: 0;
    left: 1em;
    opacity: 0;
    &:first-child {
      opacity: 1;
    }
    &-wrap {
      position: relative;
    }
  }
}
</style>